import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';
import { RelationshipsActions } from '@next/core-lib/relationships';
import { UserSelectors } from '@next/core-lib/user';
import { Store, select } from '@ngrx/store';
import { Subject } from 'rxjs';
import { RequestsOverviewModel } from 'src/app/dashboard/components/overview/models/overview.model';

import * as RequestsOverviewSlideActions from '../../../store/actions/my-advertisements.actions';

interface ActiveRequestsOverviewDialogData extends AbstractDialogData {
  selectedRequest?: RequestsOverviewModel;
}
@Component({
  selector: 'app-active-requests-slide-in-overview',
  templateUrl: './active-requests-slide-in-overview.component.html',
  styleUrls: ['./active-requests-slide-in-overview.component.scss'],
  standalone: false,
})
/* eslint-disable brace-style */
export class ActiveRequestsSlideInOverviewComponent
  extends AbstractDialog<ActiveRequestsOverviewDialogData>
  implements OnInit, OnDestroy
{
  data = inject<ActiveRequestsOverviewDialogData>(MAT_DIALOG_DATA);
  mdDialogRef =
    inject<
      MatDialogRef<
        ActiveRequestsSlideInOverviewComponent,
        AbstractDialogResultData<ActiveRequestsOverviewDialogData>
      >
    >(MatDialogRef);
  private readonly store = inject(Store);

  intermediaries: string[] = [];
  selectedLocation$ = this.store.pipe(select(UserSelectors.selectLocation));
  selectedUserLocation$ = this.store.pipe(select(UserSelectors.selectAllLocations));

  readonly destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.data.disableClose = true;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openLocationsDialog() {
    this.store.dispatch(RelationshipsActions.openLocationsDialog());
  }

  acceptMatch() {
    this.store.dispatch(
      RequestsOverviewSlideActions.acceptMatch({
        requestId: this.data.selectedRequest.id,
      }),
    );
    this.mdDialogRef.close();
  }

  rejectMatch() {
    this.store.dispatch(
      RequestsOverviewSlideActions.rejectMatch({
        requestId: this.data.selectedRequest.id,
      }),
    );
    this.mdDialogRef.close();
  }
}
